export const visit = (vm, at) => {
at({ "sv": { "conversations-visitor-experience-components": { "code-splitting": { "error": { "title": "Det uppstod ett problem med n\xE4tverksanslutningen.", "message": "Kontrollera din anslutning och f\xF6rs\xF6k igen.", "button": "F\xF6rs\xF6k igen" } } } } });
};